import { mapValues } from 'lodash';

const mapMultiItemsChartFromApi = (
  api: ApiMultiItemsChart
): MultiItemsChart => {
  return {
    points: api.points.map((item) => ({
      pointIndex: item.x,
      prices: item.y,
      date: new Date(item.label * 1000),
    })),
    data: mapValues(api.data, (value, key) => {
      return {
        color: value.color,
        isFilled: value.is_fill ?? false,
      };
    }),
    settings: {
      yMultipliers: api.settings?.y_multipliers?.map((item) => item) ?? null,
    },
  };
};

export default mapMultiItemsChartFromApi;
